export enum ImageItemPanels {
  NONE = 'none',
  SHADOW = 'shadow',
  GLOW = 'glow',
  BORDER = 'border',
  REMOVE_COLOR = 'remove-color',
  TINT = 'tint',
  MULTIPLY = 'multiply',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
  INEDITOR_CHAT = 'ineditor-chat',
}
